module.exports = __webpack_public_path__ + "img/gonzhonh.75e0d3f9.jpg";